<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          v-show="false"
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onCarparkFilterChange" />

      <AppFilterDateRange
        ref="dateRangeFilter" 
        v-bind:filterDateSingle="true"
        v-bind:filterDateMin="filterDateMin"
        v-bind:filterDateMax="filterDateMax"
        v-on:filter-data-change="onCarparkFilterChange" />

      <button v-on:click="onCSVButtonClick" type="button" class="btn btn-warning mb-1">
        Export CSV
      </button>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_parkerCarPlate',
    text: 'License Plate No.',
  },
  {
    key: '_1',
    text: 'Card No.',
  },
  {
    key: '_2',
    text: 'Card Type',
  },
  {
    key: '_3',
    text: 'Card Cost',
  },
  {
    key: '_4',
    text: 'Balance',
  },
  {
    key: 'commencementDate',
    text: 'Start Time',
    table_custom: helper.tableCustomDate,
  },
  {
    key: '_expiryDate',
    text: 'Expiry Time',
    table_custom: helper.tableCustomDate,
  },
  {
    key: 'commencementDate1',
    text: 'Registration Time',
    table_custom: helper.tableCustomDate,
  },
  {
    key: '_5',
    text: 'Card Issuing Department',
  },
  {
    key: '_6',
    text: 'Card Status',
  },
  {
    key: '_7',
    text: 'Issued By:',
  },
  {
    key: '_8',
    text: 'Parking Type',
  },
  {
    key: '_9',
    text: 'License Plate Color',
  },
  {
    key: '_10',
    text: 'Vehicle Type',
  },
  {
    key: '_11',
    text: 'License Plate Type',
  },
  {
    key: '_12',
    text: 'Vehicle color',
  },
  {
    key: '_13',
    text: 'Vehicle Brand',
  },
  {
    key: '_parkerName',
    text: 'Vehicle Owner Name',
  },
  {
    key: '_parkerMobile',
    text: 'Mobile phone No.',
  },
  {
    key: '_customerRegID',
    text: 'ID No.',
  },
  {
    key: '15',
    text: 'Address',
  },
  {
    key: '16',
    text: 'Position',
  },
  {
    key: '_companyName',
    text: 'Company',
  },
  {
    key: '18',
    text: 'Department',
  },
  {
    key: '19',
    text: 'Card Enrollment Station Type',
  },
  {
    key: '20',
    text: 'Group Name',
  },
  {
    key: '21',
    text: 'Parking Lot Permission',
  },
  {
    key: 'status',
    text: 'Subscription Status',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['stopBillDate']) {
        return 'Stop Bill';
      }
      return dataItem['status'];
    },
  },
  {
    key: '_passcardStatus',
    text: 'Passcard Status',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);
const filterDateMin = moment().startOf('month').unix()
const filterDateMax = moment().endOf('month').unix()

export default {
  name: "PageReportLPR",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppFilterDateRange,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'LPR' },
      ],

      PARAM,
      PARAM_MAP,

      isInitialSetCustomer: true,

      filterDateMin,
      filterDateMax,

      pagePasstype: null,
      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageLease: null,
      pageSeason: null,
      pageSeasonFees: {},
      pageParker: null,

      parkerPermission: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.loadPasscardType();
  },
  methods: {
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data.filter(k => k.id === 972);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(this.pageCarpark, this.$route.query.carparkID);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;

          if(response.data && response.data.length > 0) {
            response.data.forEach(k => {
              k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
              k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
            });

            this.loadPasscard();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No license data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscard() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/passcard/';

      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID);
            k['option'] = passtype ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLease() {
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/lease/';
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      // url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      let feedbackItem = 'lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage('');
            // response.data = response.data.filter(k => {
            //   let temp = this.pageCustomer.find(j => helper.compareID(j.id, k['customerID'])) || {};
            //   return this.$refs['typeFilter'].filterValue === 'Company' ? temp['isCompany'] : !temp['isCompany'];
            // });
            this.pageLease = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No lease data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLeaseData() {
      this.$refs['pageTable'].setTableData(null);

      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      if(!this.pageTermination) {
        this.loadTermination();
        return;
      }

      let temp = []
      this.pageLease.forEach(k => {
        if(!k['isParkAide']) {
          return
        }
        // if(k['status'] !== 'Active' && k['status'] !== 'Pending Termination' && k['status'] !== 'Terminated') {
        if(k['status'] !== 'Active' && k['status'] !== 'Pending Termination') {
          return
        }

        k['_license'] = this.pageLicense.find(j => helper.compareID(j.id, k['licenseID'])) || {};
        k['_licenseStatus'] = (k['_license'] || {})['status'];
        k['_licenseNum'] = (k['_license'] || {})['licenseOperatorNum'];
        k['_carparkNum'] = (k['_license'] || {})['carparkID'];
        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
        k['_customerType'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
        k['_carparkName'] = (k['_carpark'] || {}).name;

        if(k['_customerType']) {
          k['_companyName'] = k['_customer']['name']
        }
        k['_customerRegID'] = k['_customer']['nationalID']

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']);
        k['_productName'] = (k['_product'] || {}).name;
        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']);
        k['_parkerInformation'] = helper.plFormParker(k['_parker'], true);
        k['_parkerCarPlate'] = k['_parker']['car1']
        k['_parkerName'] = k['_parker']['name']
        k['_parkerMobile'] = k['_parker']['mobile']

        k['commencementDate1'] = k['commencementDate']

        if(k['isParkAide']) {
          k['_passcardStatus'] = 'ParkAide Blocked';

          if(k['status'] === 'Active' || k['status'] === 'Pending Termination') {
            if(new moment() > helper.parseDateTime(k['commencementDate'])) {
              if(!k['isBlock']) {
                k['_passcardStatus'] = 'ParkAide Active';
              }
            }
          }
        } else {
          if(k['passcardID']) {
            k['_passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, k['passcardID']));
            k['_passcardStatus'] = 'Passcard Issued';
          } else {
            if(k['status'] === 'Active' || k['status'] === 'Stop Bill') {
              if(k['reason'].includes('Pending')) {
                k['_passcardStatus'] = 'Pending Passcard Issuence';
              } else {
                k['_passcardStatus'] =  k['reason'] + ' Passcard';
              }
            } else if(k['status'] === 'Pending Termination' || k['status'].includes('Terminated')) {
              if(k['reason'].includes('Pending')) {
                k['_passcardStatus'] = 'Pending Passcard Issuence';
              } else if(k['reason'].includes('Returned')) {
                k['_passcardStatus'] = 'Passcard Returned';
              } else {
                k['_passcardStatus'] =  k['reason'] + ' Passcard';
              }
            }
          }
        }

        let startDate = this.$refs['dateRangeFilter'].filterDateStart;
        if(k['status'] === 'Active') {
          if(k['_passcardStatus'] === 'ParkAide Active') {
            k['_expiryDate'] = moment(startDate).endOf('month').unix()
          }
        }
        
        if(k['status'] === 'Active' || k['status'] === 'Pending Termination') {
          if(k['_passcardStatus'] === 'ParkAide Blocked') {
            k['_expiryDate'] = moment.unix(k['nextBillDate']).subtract(1, 'month').date(7).unix()
          }
        }
        
        if(k['status'] === 'Pending Termination' || k['status'] === 'Terminated') {
          if(k['_passcardStatus'] === 'ParkAide Active') {
            k['_termination'] = this.pageTermination.find(j => helper.compareID(j['leaseID'], k['id']) && k['status1'] !== 'Void')
            if(k['_termination']) {
              k['_expiryDate'] = moment.unix(k['_termination']['date1']).unix()
            }
          }
        }

        k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        k['_zoneName'] = (k['_zone'] || {}).name;

        temp.push(k)
      });

      // temp = temp.filter(k => k['_customer'] && (this.$refs['typeFilter'].filterValue === 'Company' ? k['_customer'].isCompany : !k['_customer'].isCompany));
      
      // let filterCustomer = this.$refs['customerFilter'].filterValue;
      // if(filterCustomer) {
      //   temp = temp.filter(k => k['_customer'] && helper.compareID(k['_customer']['id'], filterCustomer));
      // }
      
      this.$refs['pageTable'].setTablePaging(false)
      this.$refs['pageTable'].setTableData(temp);
    },
    loadSeason() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          // TODO kw1 load too much data?
          helper.SERVER_URL + '/api2/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadTermination() {
      let feedbackItem = 'termination data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/request?type1=termination',//&carparkID=' + this.$refs['carparkFilter'].filterValue,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageTermination = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No termination available.');
          }
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    onTablePageChange() {
      this.loadLease();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadLease();
    },
    onCarparkFilterChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.pageSeason = null;
      this.pageParker = null;
      this.pageTermination = null;
      this.loadLicense();
    },
    onTypeFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      // this.setCustomerFilter();
      // this.loadLeaseData();
      this.setLicenseFilter();
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLease();
    },
    onCustomerFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadLeaseData();
    },
    onLicenseFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLease();
    },

    onTableDataClick(tableData, tableDataIndex) {
    },

    onCSVButtonClick() {
      let fileSuffix = '';
      let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue)) || {name: 'All Car Parks'};
      fileSuffix += ' - ' + this.$refs['carparkFilter'].formatFilterOptionText(carpark);
      printCSV('#jt-table', 'LPR' + fileSuffix);
    }

  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportLPR.vue